export function DistributorAdminLocation({
    locationId,
    locationName,
    hasPremiumPlan,
    activeLicenseTypeUids,
} = {}) {
    return {
        locationId,
        locationName,
        hasPremiumPlan,
        activeLicenseTypeUids,
    };
}
